import { render, staticRenderFns } from "./PaymentSetting.vue?vue&type=template&id=61eec246&scoped=true"
import script from "./PaymentSetting.vue?vue&type=script&lang=js"
export * from "./PaymentSetting.vue?vue&type=script&lang=js"
import style0 from "./PaymentSetting.vue?vue&type=style&index=0&id=61eec246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eec246",
  null
  
)

export default component.exports